export default __webpack_public_path__ + "b65db0e7ec32fb673cce24146be331b9.png";